import React, { useState } from 'react'
import {
  EmotionField,
  Emotion,
  constructEmotion,
} from './EmotionField'
import InputField from './InputField'
import CheckboxField from './CheckboxField'
import { setOutSideFormField } from './Helper'
import { Button } from 'react-bootstrap'

interface Props {
  fact: string | null,
  subjectivity: string | null,
  beforeEmotion: string,
  objective: string | null,
  afterEmotion: string,
  rightAction: string | null,
  canCoachRead: string,
  submitButtonName: string,
  backLink: string,
}

const RecordForm: React.FC<Props> = (props) => {
  const [beforeEmotions, setBeforeEmotions] = useState<Emotion[]>(constructEmotion(props.beforeEmotion));
  
  const [afterEmotions, setAfterEmotions] = useState<Emotion[]>(constructEmotion(props.afterEmotion));
  
  const handleBeforeEmotionChange = (attribute: string, id: number, value: string) => {
    let newBeforeEmotion = [...beforeEmotions];
    switch (attribute) {
      case "name":
        newBeforeEmotion[id].name = value
        break;
      case "value":
        newBeforeEmotion[id].value = value;
        break;
    }
    // deep copy
    let newAfterEmotion = JSON.parse(JSON.stringify(newBeforeEmotion));
    setBeforeEmotions(newBeforeEmotion);
    setAfterEmotions(newAfterEmotion);
    setOutSideFormField("action_record_form_before_emotion", JSON.stringify(newBeforeEmotion));
    setOutSideFormField("action_record_form_after_emotion", JSON.stringify(newAfterEmotion));
  }

  const handleAfterEmotionChange = (attribute: string, id: number, value: string) => {
    let newAfterEmotion = [...afterEmotions];
    switch (attribute) {
      case "name":
        newAfterEmotion[id].name = value;
        break;
      case "value":
        newAfterEmotion[id].value = value;
        break;
    }
    setAfterEmotions(newAfterEmotion);
    setOutSideFormField("action_record_form_after_emotion", JSON.stringify(newAfterEmotion));
  }

  const handleUpdateBeforeEmotion = (emotions: Emotion[]) => {
    setBeforeEmotions(emotions);
    setAfterEmotions(JSON.parse(JSON.stringify(emotions)));// deep copy
    setOutSideFormField("action_record_form_before_emotion", JSON.stringify(emotions));
    setOutSideFormField("action_record_form_after_emotion", JSON.stringify(emotions));
  }

  const handleUpdateAfterEmotion = (emotions: Emotion[]) => {
    setAfterEmotions(emotions);
    setOutSideFormField("action_record_form_after_emotion", JSON.stringify(emotions));
  }

  return (
    <div>
      <InputField name="事実" tag="action_record_form_fact" content={props.fact} iconClass="icon-book-open" labelName="何が起こりましたか？" note="例：仕事で任されていた資料作成が間に合わず、プレゼンは簡易資料で行うことになりチームに迷惑をかけた。" />
      <InputField name="考え" tag="action_record_form_subjectivity" content={props.subjectivity} iconClass="icon-message-circle" labelName="その時どんなことを考えましたか？" note="例：自分は本当にダメだ。クビになっても仕方がない。" />
      <EmotionField emotions={beforeEmotions} tag="action_record_form_before_emotion" handleChange={handleBeforeEmotionChange} updateEmotion={handleUpdateBeforeEmotion} iconClass="icon-heart" labelName="感情" isAfter={false} />
      <InputField name="別の考え" tag="action_record_form_objective" content={props.objective} iconClass="icon-message-circle" labelName="客観的に別の考えを探してみましょう" note="例：プレゼン自体は簡易資料でもすごく支障がある訳ではなかった。完璧を求めすぎていたのかもしれない。" />
      <EmotionField emotions={afterEmotions} tag="action_record_form_after_emotion" handleChange={handleAfterEmotionChange} updateEmotion={handleUpdateAfterEmotion} iconClass="icon-heart" labelName="感情の変化" isAfter={true} beforeEmotions={beforeEmotions}/>
      <InputField name="より適応した行動" tag="action_record_form_right_action" content={props.rightAction} iconClass="icon-flag" labelName="別の考えをもとに、より適応した行動を探してみましょう" note="例：完璧に作ろうとせず、時間内でできるベストを作るようにしよう。" />

      <CheckboxField name="コーチに公開" tag="action_record_form_can_coach_read" value={props.canCoachRead}  iconClass="icon-lock" note="公開するとコーチングの際にコーチがこの記録を参考にすることができます（公開推奨）" />
      <div className="column-form-buttons">
        <Button type="submit" variant="primary mb-2" size="lg">{props.submitButtonName}</Button>{' '}
      </div>
    </div>
  )
}

export default RecordForm